import {
	ThemeProvider as MuiThemeProvider,
	StyledEngineProvider,
} from '@mui/material/styles';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { CssBaseline as MuiCssBaseline } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { Frame } from 'appContainer/Frame';
import { msalConfig } from 'b2c/b2cConf';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { SnackbarProvider } from 'notistack';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { notistackConfig } from 'styles/theme/Notistack';
import { themeSystem } from 'styles/theme/ThemeSystem';
import { store } from './store/store';
import { theme } from './styles/theme/ThemeStyle';
import TranslationProvider from 'utils/TranslationProvider';

const pca = new PublicClientApplication(msalConfig);

export const App: FC = () => {
	dayjs.extend(utc);
	dayjs.extend(timezone);
	dayjs.extend(customParseFormat);

	return (
		<Provider store={store}>
			<MsalProvider instance={pca}>
				{/* <TolgeeProvider tolgee={tolgee}> */}
				<TranslationProvider>
					<StyledEngineProvider injectFirst>
						<MuiThemeProvider theme={deepmerge(themeSystem, theme)}>
							<MuiCssBaseline />
							<StyledComponentsThemeProvider theme={theme}>
								<SnackbarProvider {...notistackConfig}>
									<Frame />
								</SnackbarProvider>
							</StyledComponentsThemeProvider>
						</MuiThemeProvider>
					</StyledEngineProvider>
				</TranslationProvider>
				{/* </TolgeeProvider> */}
			</MsalProvider>
		</Provider>
	);
};
